import React, {useState} from 'react';
import Modal from '../../component/Inc/Modal';
function PopManageCategory(props) {
  const {open, close} = props;
  //const [modalAlert, setModalAlert] = useState(false);
  const listItems1 = ['2020', '2021', '2022', '2023', ' 2024'];
  const listItems2 = ['국어', '수학', '영어', ' 과학', '사회', '수학', '영어'];
  const [selectedItems, setSelectedItems] = useState({
    type1: null,
    type2: null,
    type3: null,
    type4: null,
    type5: null,
    type6: null
  });
  const handleItemClick = (section, index) => {
    setSelectedItems((prevState) => ({
      ...prevState,
      [section]: index
    }));
  };
  return (
    <Modal open={open} close={close} type="pop_manage_category">
      <h2 className="pop_tit">카테고리 관리</h2>
      <div className="content_container scroll">
        <div className="com_input_wrap">
          <select className="select">
            <option value="과목 선택">과목 선택</option>
          </select>
        </div>
        <section className="select_wrap">
          <div className="com_input_wrap flex_between">
            <div className="tit">구분1</div>
            <button className="com_btn orange xs btn_settings">구분 설정</button>
          </div>
          <select className="select xs">
            <option value="구분">구분1</option>
          </select>
          <div className="com_scroll_list_wrap">
            <ul className="com_scroll_list pick mb_no">
              {listItems1.map((item, subIdx) => (
                <li key={subIdx} className={`item ${selectedItems.type1 === subIdx ? 'selected' : ''}`} onClick={() => handleItemClick('type1', subIdx)}>
                  {item}
                </li>
              ))}
            </ul>
            <button className="com_btn orange xxs ">
              <i className="btn_plus"></i>추가
            </button>
          </div>
          <div className="com_input_wrap flex_row">
            <button className="com_btn line li lightGray xs btn_delete"></button>
            <input type="text" className="input xs" defaultValue={`2024`} />
            <button className="com_btn gray xs ">등록</button>
          </div>
        </section>
        <section className="select_wrap">
          <div className="tit">구분2</div>
          <select className="select xs">
            <option value="구분">구분2</option>
          </select>
          <div className="com_scroll_list_wrap">
            <ul className="com_scroll_list pick mb_no">
              {listItems2.map((item, subIdx) => (
                <li key={subIdx} className={`item ${selectedItems.type2 === subIdx ? 'selected' : ''}`} onClick={() => handleItemClick('type2', subIdx)}>
                  {item}
                </li>
              ))}
            </ul>
            <button className="com_btn orange xxs ">
              <i className="btn_plus"></i>추가
            </button>
          </div>
          <div className="com_input_wrap flex_row">
            <button className="com_btn line li lightGray xs btn_delete"></button>
            <input type="text" className="input xs" defaultValue={`수학`} />
            <button className="com_btn gray xs ">등록</button>
          </div>
        </section>
        <section className="select_wrap">
          <div className="tit">구분3</div>
          <select className="select xs">
            <option value="구분">구분3</option>
          </select>
          <div className="com_scroll_list_wrap">
            <ul className="com_scroll_list pick mb_no">
              {listItems2.map((item, subIdx) => (
                <li key={subIdx} className={`item ${selectedItems.type3 === subIdx ? 'selected' : ''}`} onClick={() => handleItemClick('type3', subIdx)}>
                  {item}
                </li>
              ))}
            </ul>
            <button className="com_btn orange xxs ">
              <i className="btn_plus"></i>추가
            </button>
          </div>
          <div className="com_input_wrap flex_row">
            <button className="com_btn line li lightGray xs btn_delete"></button>
            <input type="text" className="input xs" defaultValue={`수학`} />
            <button className="com_btn gray xs ">등록</button>
          </div>
        </section>
        <section className="select_wrap">
          <div className="tit">구분4</div>
          <select className="select xs">
            <option value="구분4">구분4</option>
          </select>
          <div className="com_scroll_list_wrap">
            <ul className="com_scroll_list pick mb_no">
              {listItems2.map((item, subIdx) => (
                <li key={subIdx} className={`item ${selectedItems.type4 === subIdx ? 'selected' : ''}`} onClick={() => handleItemClick('type4', subIdx)}>
                  {item}
                </li>
              ))}
            </ul>
            <button className="com_btn orange xxs ">
              <i className="btn_plus"></i>추가
            </button>
          </div>
          <div className="com_input_wrap flex_row">
            <button className="com_btn line li lightGray xs btn_delete"></button>
            <input type="text" className="input xs" defaultValue={`수학`} />
            <button className="com_btn gray xs ">등록</button>
          </div>
        </section>
        <section className="select_wrap">
          <div className="tit">구분5</div>
          <select className="select xs">
            <option value="구분5">구분5</option>
          </select>
          <div className="com_scroll_list_wrap">
            <ul className="com_scroll_list pick mb_no">
              {listItems2.map((item, subIdx) => (
                <li key={subIdx} className={`item ${selectedItems.type5 === subIdx ? 'selected' : ''}`} onClick={() => handleItemClick('type5', subIdx)}>
                  {item}
                </li>
              ))}
            </ul>
            <button className="com_btn orange xxs ">
              <i className="btn_plus"></i>추가
            </button>
          </div>
          <div className="com_input_wrap flex_row">
            <button className="com_btn line li lightGray xs btn_delete"></button>
            <input type="text" className="input xs" defaultValue={`수학`} />
            <button className="com_btn gray xs ">등록</button>
          </div>
        </section>
        <section className="select_wrap">
          <div className="tit">구분6</div>
          <select className="select xs">
            <option value="구분6">구분6</option>
          </select>
          <div className="com_scroll_list_wrap">
            <ul className="com_scroll_list pick mb_no">
              {listItems2.map((item, subIdx) => (
                <li key={subIdx} className={`item ${selectedItems.type6 === subIdx ? 'selected' : ''}`} onClick={() => handleItemClick('type6', subIdx)}>
                  {item}
                </li>
              ))}
            </ul>
            <button className="com_btn orange xxs ">
              <i className="btn_plus"></i>추가
            </button>
          </div>
          <div className="com_input_wrap flex_row">
            <button className="com_btn line li lightGray xs btn_delete"></button>
            <input type="text" className="input xs" defaultValue={`수학`} />
            <button className="com_btn gray xs ">등록</button>
          </div>
        </section>
      </div>
      <div className="btn_container">
        <button className="com_btn orange xs">저장</button>
      </div>
    </Modal>
  );
}

export default PopManageCategory;
